 <template>
  <el-row class="el-row_h">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow: auto">
        <el-input style="min-width: 150px;" placeholder="请输入关键字搜索" v-model="keyWord" clearable size="small" class="s_padding filterSelect">
        </el-input>
        <el-input style="min-width: 170px;" placeholder="请输入品种关键字搜索" v-model="ContractKeyVal" clearable size="small" class="s_padding filterSelect">
        </el-input>
        <dateRangeHis ref="dateRange"></dateRangeHis>
        <el-select style="min-width: 80px;" v-model="PositionEffectValue" size="small" placeholder="请选择" class="s_padding">
          <el-option v-for="item in PositionEffectList" :key="item.Code" :label="item.Name" :value="item.Code">
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getList()">查询</el-button>
      </div>
      <div style="height: 100%;">
        <tableCom :data="dealList" v-loading="loading"></tableCom>
      </div>
      <div class="pagination_mb2 text-center">
        <pagination :pagerPro="Pager" @ee="pageFn"></pagination>
      </div>
      <div class="footer grid-content bg-purple layout_box">
        <span class="text-right">
          手续费合计:
          <span class="capital">{{SubAccountLimit ? totalCapital : "***"}}</span>
          <span class="Currency"> ({{CurrencyName}})</span>
          &nbsp;&nbsp;&nbsp; 平仓盈亏:
          <span class="capital">{{totalCurrency}}</span>
          <span class="Currency"> ({{CurrencyName}})</span>
        </span>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import tableCom from "./dealDetailT.vue";
import pagination from "../../paging.vue";
import dateRangeHis from "../../dateRangeSubHis.vue";
import SeachConPage from "../SeachConPage.vue";

export default {
  // 筛选器
  name: "dealDetailS",
  props: ["agentID"],
  components: {
    tableCom,
    pagination,
    dateRangeHis,
    SeachConPage
  },
  data() {
    return {
      loading: "",
      Pager: {
        PageNo: 1,
        PageSize: 10,
        RecordCount: 0
      },
      dealList: [],
      totalCapital: 0,
      totalCurrency: 0,
      keyWord: "",
      ContractKeyVal: "",
      PositionEffectValue: 1,
      PositionEffectList: [
        { Code: 0, Name: "全部" },
        { Code: 1, Name: "开仓" },
        { Code: 2, Name: "平仓" },
        { Code: 3, Name: "平开" }
      ],
      queryobj:{},
      SubAccountLimit: true,
      CurrencyName: '',
    };
  },
  mounted() {
     if (sessionStorage.getItem("type") == "1"){
      if (sessionStorage.getItem("SubAccountLimit") != null && sessionStorage.getItem("SubAccountLimit") != "undefined") {
        this.SubAccountLimit = JSON.parse(sessionStorage.getItem("SubAccountLimit"));
      }
    }
    this.PositionEffectValue = this.PositionEffectList[0].Code;
    this.getList();
    this.getCurrencyName();
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    getList(isSearch = true) {
      if (isSearch) {
        this.Pager = {
          PageNo: 1,
          PageSize: 20,
          RecordCount: 0
        };
      }
      this.queryobj={
        UserKey:this.keyWord,
        ContractKey: this.ContractKeyVal,
        PositionEffect: this.PositionEffectValue,
        BeginDate: this.$refs.dateRange.DateRangeValue[0],
        EndDate: this.$refs.dateRange.DateRangeValue[1]
      }
      this.$emit("dealDetail", this.queryobj);
      this.loading = true;
      let url = "/report/QryAgentUserHistoryTrade";
      let postData = {
        AgentIds: this.agentID,
        UserKey: this.keyWord,
        PositionEffect: this.PositionEffectValue,
        ContractKey: this.ContractKeyVal,
        BeginDate: this.$refs.dateRange.DateRangeValue[0],
        EndDate: this.$refs.dateRange.DateRangeValue[1]
      };
      this.$loginapi.postWithPage(
        url,
        this.Pager.PageNo,
        this.Pager.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.dealList = response.Data.Records;
            this.totalCapital = response.Data.Commission;
            this.totalCurrency = response.Data.CloseProfit;

            if (this.Pager.PageNo == 1) {
              this.Pager = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getList(false);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selects/dealDetail/dealDetailS.vue